import { registerAction } from '../../Action'

const LOAD_ME = 'LOAD_ME'

const reducer = (state = {}, action) => {
  const me = {
    imageUrl: action.payload.image_url,
    name: `${action.payload.first_name} ${action.payload.last_name}`,
    companyName: action.payload.company.name,
    id: action.payload.id,
    avatarAssetReferenceUuid: action.payload.avatar_asset_reference_uuid,
  }
  return {
    ...state,
    me,
  }
}

const loadMe = registerAction(LOAD_ME, { reducer })

export default loadMe
